export default __webpack_public_path__ + "static/media/thum_4.92e21324.png";